// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"Av","imageWrapper":"Aw","image":"Ax","copyrightAndBrandLogo":"Ay","brandLogo":"Az","copyright":"AA","rentalBadge":"AB"};